/**
 * Store listing saves `category` and `subcategory` as display names (not numeric ids).
 */

export function isLocationsName(str) {
  const s = String(str || "").trim().toLowerCase();
  return s === "location" || s === "locations";
}

/**
 * @param {string} apiBase
 * @param {string|undefined|null} categoryName
 * @param {string|undefined|null} subcategoryName
 * @returns {Promise<boolean>}
 */
export async function resolveIsLocationCategory(apiBase, categoryName, subcategoryName) {
  if (isLocationsName(categoryName)) return true;

  const sub = String(subcategoryName || "").trim();
  if (!sub) return false;

  const base = (apiBase || "").replace(/\/+$/, "");
  try {
    const res = await fetch(
      `${base}/subcategory/resolve-by-name/${encodeURIComponent(sub)}`
    );
    if (!res.ok) return false;
    const data = await res.json();
    const catName = data?.category?.category_name;
    return isLocationsName(catName);
  } catch {
    return false;
  }
}
